'use strict';/* global define:false */define('modules/core/modules/utils/values/keys',[],function(){'use strict';return{backspace:8,tab:9,enter:13,esc:27,space:32,left:37,up:38,right:39,down:40,comma:188};});
